/// <reference path="../../../assets/js/App.ts" />
/// <reference path="../../../assets/js/app/AbsWidget.ts" />
/// <reference path="../../../assets/js/definitions/jquery.d.ts" />
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Plugins;
    (function (Plugins) {
        var Login = (function (_super) {
            __extends(Login, _super);
            function Login() {
                _super.call(this);
                this.gateway = App.Main.data.site_url + "/webdesk/";
                console.log("Login.constructor()");
            }
            Login.prototype.init = function (widget_data) {
                var _this = this;
                _super.prototype.init.call(this, widget_data);
                this.form = jQuery("#dlform");
                this.form.on("submit", function (e) { return _this.onsubmit(e); });
                //
                this.service_links = jQuery(".service-link");
                //
                this.select_studio = jQuery("#codstudio");
                this.select_studio.on("change", function (e) { return _this.studio_onChange(e); });
                this.studio_onChange();
                //
                setTimeout(function () {
                    _this.form.trigger("reset");
                }, 1000);
            };
            Login.prototype.studio_onChange = function (e) {
                var value = this.select_studio.val();
                //
                this.service_links.each(function (index, element) {
                    var jq_element = jQuery(element);
                    var template = jq_element.attr("href-template");
                    var new_link = template.replace("{id-studio}", value);
                    jq_element.attr("href", new_link);
                });
            };
            Login.prototype.onsubmit = function (e) {
                var _this = this;
                setTimeout(function () {
                    _this.form.trigger("reset");
                }, 1000);
                /*
                e.preventDefault();
                console.log("submit");
                //
                this.form.find(".message").html("").addClass("hidden");
                //
                var settings = {
                    url: this.gateway,
                    method: "POST",
                    xhrFields: {withCredentials: false},
                    crossDomain: true,
                    data: {
                        "codstudio": "ANAST1",
                        "login": this.form.find("#dl_login").val(),
                        "password": this.form.find("#dl_pass").val(),
                        "autoRedirect": "false"
                    },
                    dataType: "html"
                };
                var request:JQueryXHR = jQuery.ajax(settings);
                request.done(( msg:string ) => {
                    if (msg.slice(0,4)==="http") {
                        console.log("redirecting to "+msg);
                    } else {
                        console.log("error");
                        window["msg"] = msg;
                        console.log(/warning_custom_error.+\>(.+)<\/span>/g.exec(msg)[1]);
    
                    }
                });
                request.fail(( jqXHR, textStatus ) => {
                    console.warn( "Request failed: " + textStatus );
                    this.form.find(".message").html("Login fallita<br>"+textStatus).removeClass("hidden");
                });
                return false;
                */
                /*
                var responder:Responder = new Responder(this.onResponse, this.onErrore, this);
                this.call(this.form.find("#dl_login").val(),this.form.find("#dl_pass").val(),responder);
                */
            };
            return Login;
        }(App.AbsWidget));
        Plugins.Login = Login;
    })(Plugins = App.Plugins || (App.Plugins = {}));
})(App || (App = {}));
if (typeof data_Login !== 'undefined') {
    var main_Login = new App.Plugins.Login();
    main_Login.init(data_Login);
}
